import { render, staticRenderFns } from "./programPrice.vue?vue&type=template&id=4084ed32&scoped=true&"
import script from "./programPrice.vue?vue&type=script&lang=js&"
export * from "./programPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084ed32",
  null
  
)

export default component.exports